import { Box, Typography, Grid } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { Button as SharedButton } from "../../../shared/components/ui/Button";
import { SummaryCards } from "../components/SummaryCards";
import { UsersChart } from "../components/UsersChart";
import { AccessChart } from "../components/AccessChart";
import { AccessLogTable } from "../components/AccessLogTable";
import { VisitorTable } from "../components/VisitorTable";
import { ReservationTable } from "../components/ReservationTable";
import { useDashboard } from "../context/useDashboard";
import { DashboardSkeleton } from "../components/DashboardSkeleton";
import { Can } from "../../../shared/components/Permission";
import DashboardComingSoon from "../components/DashboardComingSoon";
import { ROLES } from "../../../shared/constants/roles";

const Dashboard = () => {
  const {  isLoadingActiveUserGraph, isLoadingAccessLogGraph, isLoadingAccessLogs, isLoadingDashboardCounts, isLoadingDashboardSummaryToday } = useDashboard();

  console.log( isLoadingActiveUserGraph, isLoadingAccessLogGraph, isLoadingAccessLogs, isLoadingDashboardCounts, isLoadingDashboardSummaryToday);
  if ( isLoadingActiveUserGraph || isLoadingAccessLogGraph || isLoadingAccessLogs || isLoadingDashboardCounts || isLoadingDashboardSummaryToday) {
    return <DashboardSkeleton />;
  }

  return (
    <>
      {/* Dashboard para ADMIN e GESTOR */}
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          mb={3}
        >
          <Typography variant="h5" fontWeight={700}>
            Dashboard
          </Typography>

        </Box>

        <SummaryCards />

        <Grid container spacing={2} mb={2}>
            <Grid item xs={12} md={6}>
              <UsersChart />
            </Grid>
            <Grid item xs={12} md={6}>
              <AccessChart />
            </Grid>
        </Grid>
        <Grid container spacing={2} mb={2}>
          <Grid item xs={12}>
            <AccessLogTable />
          </Grid>
        </Grid>
       

        <Grid container spacing={2}>
          <Grid item xs={6}>
            <VisitorTable />
          </Grid>
          <Grid item xs={6}>
            <ReservationTable />
          </Grid>
        </Grid>

      {/* Dashboard personalizado para USER e CUSTOMER */}
      {/* <Can roles={['USER', 'CUSTOMER']}>
        <DashboardComingSoon />
      </Can> */}
    </>
  );
};

export default Dashboard;
